"use strict";

exports.__esModule = true;
exports.fetchPageAppSettings = fetchPageAppSettings;
exports.updateCustomAppSettingsValue = exports.updateBooleanValueOnStore = exports.updateNumericValueOnStore = exports.updateAppSettingsOnStore = exports.updateAppSettings = exports.updateAppSettingsFailure = exports.updateAppSettingsSuccess = exports.updateAppSettingsRequest = exports.UPDATE_APP_SETTINGS_ON_STORE = exports.UPDATE_APP_SETTINGS_FAILURE = exports.UPDATE_APP_SETTINGS_SUCCESS = exports.UPDATE_APP_SETTINGS_REQUEST = exports.fetchAppSettingsFailure = exports.fetchAppSettingsSuccess = exports.fetchAppSettingsRequest = exports.FETCH_APP_SETTINGS_FAILURE = exports.FETCH_APP_SETTINGS_SUCCESS = exports.FETCH_APP_SETTINGS_REQUEST = exports.setAppSettings = exports.SET_APP_SETTINGS = void 0;
var SET_APP_SETTINGS = 'appSettings/SET_APP_SETTINGS';
exports.SET_APP_SETTINGS = SET_APP_SETTINGS;

var setAppSettings = function setAppSettings(payload) {
  return function (dispatch) {
    dispatch({
      type: SET_APP_SETTINGS,
      payload: payload
    });
    return Promise.resolve();
  };
};

exports.setAppSettings = setAppSettings;
var FETCH_APP_SETTINGS_REQUEST = 'appSettings/FETCH_REQUEST';
exports.FETCH_APP_SETTINGS_REQUEST = FETCH_APP_SETTINGS_REQUEST;
var FETCH_APP_SETTINGS_SUCCESS = 'appSettings/FETCH_SUCCESS';
exports.FETCH_APP_SETTINGS_SUCCESS = FETCH_APP_SETTINGS_SUCCESS;
var FETCH_APP_SETTINGS_FAILURE = 'appSettings/FETCH_FAILURE';
exports.FETCH_APP_SETTINGS_FAILURE = FETCH_APP_SETTINGS_FAILURE;

var fetchAppSettingsRequest = function fetchAppSettingsRequest() {
  return {
    type: FETCH_APP_SETTINGS_REQUEST
  };
};

exports.fetchAppSettingsRequest = fetchAppSettingsRequest;

var fetchAppSettingsSuccess = function fetchAppSettingsSuccess(payload) {
  return {
    type: FETCH_APP_SETTINGS_SUCCESS,
    payload: payload
  };
};

exports.fetchAppSettingsSuccess = fetchAppSettingsSuccess;

var fetchAppSettingsFailure = function fetchAppSettingsFailure() {
  return {
    type: FETCH_APP_SETTINGS_FAILURE
  };
};

exports.fetchAppSettingsFailure = fetchAppSettingsFailure;

function fetchPageAppSettings(viewMode) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;
    dispatch(fetchAppSettingsRequest());
    viewMode = viewMode === '' ? 'site' : viewMode;
    var promise = request("/settings/page?viewMode=" + viewMode);
    return promise.then(function (settings) {
      return dispatch(fetchAppSettingsSuccess(settings));
    }, function () {
      return dispatch(fetchAppSettingsFailure());
    }).then(function () {
      return promise;
    });
  };
}

var UPDATE_APP_SETTINGS_REQUEST = 'appSettings/UPDATE_REQUEST';
exports.UPDATE_APP_SETTINGS_REQUEST = UPDATE_APP_SETTINGS_REQUEST;
var UPDATE_APP_SETTINGS_SUCCESS = 'appSettings/UPDATE_SUCCESS';
exports.UPDATE_APP_SETTINGS_SUCCESS = UPDATE_APP_SETTINGS_SUCCESS;
var UPDATE_APP_SETTINGS_FAILURE = 'appSettings/UPDATE_FAILURE';
exports.UPDATE_APP_SETTINGS_FAILURE = UPDATE_APP_SETTINGS_FAILURE;
var UPDATE_APP_SETTINGS_ON_STORE = 'appSettings/UPDATE_ON_STORE';
exports.UPDATE_APP_SETTINGS_ON_STORE = UPDATE_APP_SETTINGS_ON_STORE;

var updateAppSettingsRequest = function updateAppSettingsRequest(payload, externalId) {
  return {
    type: UPDATE_APP_SETTINGS_REQUEST,
    payload: payload,
    meta: {
      bi: {
        externalId: externalId
      }
    }
  };
};

exports.updateAppSettingsRequest = updateAppSettingsRequest;

var updateAppSettingsSuccess = function updateAppSettingsSuccess(payload) {
  return {
    type: UPDATE_APP_SETTINGS_SUCCESS,
    payload: payload
  };
};

exports.updateAppSettingsSuccess = updateAppSettingsSuccess;

var updateAppSettingsFailure = function updateAppSettingsFailure() {
  return {
    type: UPDATE_APP_SETTINGS_FAILURE
  };
}; // eslint-disable-next-line max-params


exports.updateAppSettingsFailure = updateAppSettingsFailure;

var updateAppSettings = function updateAppSettings(compId, externalId, viewMode, settings, isMainPage) {
  if (isMainPage === void 0) {
    isMainPage = false;
  }

  return function (dispatch, getState, _ref2) {
    var request = _ref2.request;
    dispatch(updateAppSettingsRequest(settings, externalId));
    return request.post("/settings?compId=" + compId + "&externalId=" + externalId + "&viewMode=" + viewMode + "&isMainPage=" + isMainPage, settings).then(function (responseData) {
      return dispatch(updateAppSettingsSuccess(responseData));
    })["catch"](function () {
      return dispatch(updateAppSettingsFailure());
    });
  };
}; // only perform update localy - do not change the settings on server - this is used in wix change style in the editor (before save/publish)


exports.updateAppSettings = updateAppSettings;

var updateAppSettingsOnStore = function updateAppSettingsOnStore(payload) {
  return {
    type: UPDATE_APP_SETTINGS_ON_STORE,
    payload: payload
  };
};

exports.updateAppSettingsOnStore = updateAppSettingsOnStore;

var updateNumericValueOnStore = function updateNumericValueOnStore(key, value) {
  var _numbers;

  return updateAppSettingsOnStore({
    style: {
      numbers: (_numbers = {}, _numbers[key] = parseInt(value, 10), _numbers)
    }
  });
};

exports.updateNumericValueOnStore = updateNumericValueOnStore;

var updateBooleanValueOnStore = function updateBooleanValueOnStore(key, value) {
  var _booleans;

  return updateAppSettingsOnStore({
    style: {
      booleans: (_booleans = {}, _booleans[key] = value, _booleans)
    }
  });
};

exports.updateBooleanValueOnStore = updateBooleanValueOnStore;

var updateCustomAppSettingsValue = function updateCustomAppSettingsValue(key, value) {
  var _custom;

  return updateAppSettingsOnStore({
    custom: (_custom = {}, _custom[key] = value, _custom)
  });
};

exports.updateCustomAppSettingsValue = updateCustomAppSettingsValue;